import { FC } from 'react';
import { Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

/**
 * Inline info icon with a German explanation on hover. The house pattern for
 * "label + what does this number mean" — keep the wording jargon-free, the
 * readers are Marketing, not engineers.
 *
 * Sits next to the label it explains; for a full "how does this work" block use
 * `Explainer` instead.
 */
const InfoTip: FC<{ text: string }> = ({ text }) => (
  // Antippen zeigt die Erklärung sofort (Touch) und löst NICHT den Knopf aus, in dem das Symbol sitzt — in einem
  // Sortierkopf sortierte ein Tipp aufs (i) sonst die Spalte. Per Tastatur erreichbar (Bedienprüfung 28.10.).
  <Tooltip title={text} arrow placement="top" enterTouchDelay={0}>
    <InfoOutlinedIcon
      tabIndex={0}
      onClick={(e) => e.stopPropagation()}
      sx={{
        fontSize: 15,
        ml: 0.5,
        color: 'text.secondary',
        cursor: 'help',
        verticalAlign: 'middle',
        flexShrink: 0,
      }}
    />
  </Tooltip>
);

export default InfoTip;
